var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.countries
    ? _c("div", [
        _c(
          "a",
          {
            staticClass: "theme-btn theme-btn-small mb-3",
            on: { click: _vm.addPassenger },
          },
          [_vm._v("+Add Passenger")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-12" },
            _vm._l(_vm.passengers, function (passenger, index) {
              return _c("div", { staticClass: "form-box" }, [
                _c("div", { staticClass: "form-title-wrap" }, [
                  _c("h3", { staticClass: "title" }, [
                    _vm._v(_vm._s(index + 1) + ". Yolcu"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "theme-btn theme-btn-small",
                      on: {
                        click: function ($event) {
                          return _vm.remove(passenger)
                        },
                      },
                    },
                    [_vm._v("Çıkar")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-content " }, [
                  _c("div", { staticClass: "contact-form-action" }, [
                    _c("form", { attrs: { id: "passenger-" + index } }, [
                      _c("div", { staticClass: "row align-items-end" }, [
                        _c("div", { staticClass: "col-7 col-sm-6" }, [
                          _c("div", { staticClass: "input-box" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "div",
                                { staticClass: "select-contain w-auto" },
                                [
                                  _c(
                                    "v-app",
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          filter: _vm.filterCruiseRooms,
                                          items: _vm.filteredCruiseRoomList,
                                          flat: "",
                                          "hide-no-data": "",
                                          "hide-details": "",
                                          "item-value": "id",
                                          placeholder: "Kabin",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "selection",
                                              fn: function (ref) {
                                                var item = ref.item
                                                var selected = ref.selected
                                                return [
                                                  _vm._v(
                                                    "\n                                  " +
                                                      _vm._s(item.roomNumber) +
                                                      " " +
                                                      _vm._s(
                                                        item.ros ? "(ROS)" : ""
                                                      ) +
                                                      " - " +
                                                      _vm._s(
                                                        _vm.getRoomName(
                                                          item.roomId
                                                        )
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "item",
                                              fn: function (ref) {
                                                var item = ref.item
                                                var tile = ref.tile
                                                return [
                                                  _c("v-list-tile-content", [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          item.roomNumber
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          item.ros
                                                            ? "(ROS)"
                                                            : ""
                                                        ) +
                                                        " - " +
                                                        _vm._s(
                                                          _vm.getRoomName(
                                                            item.roomId
                                                          )
                                                        ) +
                                                        "\n                                  "
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: passenger.cruiseRoomId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              passenger,
                                              "cruiseRoomId",
                                              $$v
                                            )
                                          },
                                          expression: "passenger.cruiseRoomId",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-5 col-md-3" }, [
                          _c("div", { staticClass: "input-box" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [_c("cabin-view-popup")],
                              1
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-lg-6 responsive-column" },
                          [
                            _c("base-edit-input", {
                              attrs: {
                                rules: "required",
                                type: "text",
                                label: "İsim",
                              },
                              model: {
                                value: passenger.name,
                                callback: function ($$v) {
                                  _vm.$set(passenger, "name", $$v)
                                },
                                expression: "passenger.name",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-lg-6 responsive-column" },
                          [
                            _c("base-edit-input", {
                              attrs: {
                                rules: "required",
                                type: "text",
                                label: "Soyisim",
                              },
                              model: {
                                value: passenger.lastName,
                                callback: function ($$v) {
                                  _vm.$set(passenger, "lastName", $$v)
                                },
                                expression: "passenger.lastName",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-lg-6 responsive-column" },
                          [
                            _c("base-date-input", {
                              attrs: {
                                rules: "birthdate",
                                type: "text",
                                label: "Doğum Tarihi",
                              },
                              model: {
                                value: passenger.birthDate,
                                callback: function ($$v) {
                                  _vm.$set(passenger, "birthDate", $$v)
                                },
                                expression: "passenger.birthDate",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-lg-6 responsive-column" },
                          [
                            _c("base-select-input", {
                              attrs: {
                                optionList: [
                                  { name: "Female", id: "female" },
                                  { name: "Male", id: "male" },
                                ],
                                rules: "required",
                                type: "text",
                                label: "Cinsiyet",
                              },
                              model: {
                                value: passenger.gender,
                                callback: function ($$v) {
                                  _vm.$set(passenger, "gender", $$v)
                                },
                                expression: "passenger.gender",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-lg-6 responsive-column" },
                          [
                            _c("base-edit-input", {
                              attrs: { type: "text", label: "TC" },
                              model: {
                                value: passenger.tckNo,
                                callback: function ($$v) {
                                  _vm.$set(passenger, "tckNo", $$v)
                                },
                                expression: "passenger.tckNo",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !passenger.isTurkishCitizen || _vm.countries
                          ? _c(
                              "div",
                              { staticClass: "col-lg-6 responsive-column" },
                              [
                                _vm.projectName === "selectum"
                                  ? _c("base-select-input", {
                                      attrs: {
                                        optionList: _vm.countries,
                                        "id-key": "code2",
                                        type: "text",
                                        label: "Ülke",
                                      },
                                      model: {
                                        value: passenger.country,
                                        callback: function ($$v) {
                                          _vm.$set(passenger, "country", $$v)
                                        },
                                        expression: "passenger.country",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.projectName === "miray"
                                  ? _c("base-select-input", {
                                      attrs: {
                                        optionList: _vm.countries,
                                        "id-key": "id",
                                        type: "text",
                                        label: "Ülke",
                                      },
                                      model: {
                                        value: passenger.country,
                                        callback: function ($$v) {
                                          _vm.$set(passenger, "country", $$v)
                                        },
                                        expression: "passenger.country",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "passoport",
                          class: passenger.isTurkishCitizen,
                          attrs: { attr: passenger.isTurkishCitizen },
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-lg-6 responsive-column" },
                              [
                                _c("base-edit-input", {
                                  attrs: {
                                    type: "text",
                                    label: "Passaport No",
                                  },
                                  model: {
                                    value: passenger.passportNumber,
                                    callback: function ($$v) {
                                      _vm.$set(passenger, "passportNumber", $$v)
                                    },
                                    expression: "passenger.passportNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-lg-6 responsive-column" },
                              [
                                _c("base-select-input", {
                                  attrs: {
                                    optionList: [
                                      { name: "Bordo", id: "Bordo" },
                                      { name: "Yesil", id: "Yesil" },
                                      { name: "Gri", id: "Gri" },
                                      { name: "Siyah", id: "Siyah" },
                                      { name: "Kırmızı", id: "Kırmızı" },
                                    ],
                                    type: "text",
                                    label: "Passaport Türü *",
                                  },
                                  model: {
                                    value: passenger.passportType,
                                    callback: function ($$v) {
                                      _vm.$set(passenger, "passportType", $$v)
                                    },
                                    expression: "passenger.passportType",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-lg-6 responsive-column" },
                              [
                                _c("base-date-input", {
                                  attrs: {
                                    type: "text",
                                    label: "Veriliş Tarihi",
                                  },
                                  model: {
                                    value: passenger.issueDate,
                                    callback: function ($$v) {
                                      _vm.$set(passenger, "issueDate", $$v)
                                    },
                                    expression: "passenger.issueDate",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-lg-6 responsive-column" },
                              [
                                _c("base-date-input", {
                                  attrs: {
                                    type: "text",
                                    label: "Son Geçerlilik Tarihi",
                                  },
                                  model: {
                                    value: passenger.expireDate,
                                    callback: function ($$v) {
                                      _vm.$set(passenger, "expireDate", $$v)
                                    },
                                    expression: "passenger.expireDate",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-lg-6 responsive-column" },
                              [
                                _c("base-edit-input", {
                                  attrs: {
                                    type: "text",
                                    label: "Verildiği Yer",
                                  },
                                  model: {
                                    value: passenger.issuedPlace,
                                    callback: function ($$v) {
                                      _vm.$set(passenger, "issuedPlace", $$v)
                                    },
                                    expression: "passenger.issuedPlace",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ])
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-4" }, [
          _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "form-box" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "form-content " }, [
                _c("div", { staticClass: "contact-form-action" }, [
                  _c("form", { attrs: { id: "contactForm" } }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-lg-4 responsive-column" },
                        [
                          _c("base-edit-input", {
                            attrs: {
                              rules: "required",
                              type: "text",
                              label: "İsim Soyisim",
                            },
                            model: {
                              value: _vm.contactName,
                              callback: function ($$v) {
                                _vm.contactName = $$v
                              },
                              expression: "contactName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-lg-4 responsive-column" },
                        [
                          _c("base-edit-input", {
                            attrs: {
                              rules: "required",
                              type: "text",
                              label: "Eposta",
                            },
                            model: {
                              value: _vm.contactEmail,
                              callback: function ($$v) {
                                _vm.contactEmail = $$v
                              },
                              expression: "contactEmail",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-lg-4 responsive-column" },
                        [
                          _c("base-phone-input", {
                            attrs: {
                              "uu-id": "contactPhone",
                              label: "Telefon Numarası",
                            },
                            model: {
                              value: _vm.contactPhone,
                              callback: function ($$v) {
                                _vm.contactPhone = $$v
                              },
                              expression: "contactPhone",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.projectName === "miray"
          ? _c("div", { staticClass: "row mt-4" }, [
              _c("div", { staticClass: "col-lg-12" }, [
                _c("div", { staticClass: "form-box" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-content " }, [
                    _c("div", { staticClass: "contact-form-action" }, [
                      _c("form", { attrs: { id: "emergencyForm" } }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-lg-4 responsive-column" },
                            [
                              _c("base-edit-input", {
                                attrs: { type: "text", label: "İsim Soyisim" },
                                model: {
                                  value: _vm.emergencyContactName,
                                  callback: function ($$v) {
                                    _vm.emergencyContactName = $$v
                                  },
                                  expression: "emergencyContactName",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-4 responsive-column" },
                            [
                              _c("base-edit-input", {
                                attrs: { type: "text", label: "Eposta" },
                                model: {
                                  value: _vm.emergencyContactEmail,
                                  callback: function ($$v) {
                                    _vm.emergencyContactEmail = $$v
                                  },
                                  expression: "emergencyContactEmail",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-4 responsive-column" },
                            [
                              _c("base-phone-input", {
                                attrs: {
                                  "uu-id": "emergencyContactPhone",
                                  label: "Telefon Numarası",
                                },
                                model: {
                                  value: _vm.emergencyContactPhone,
                                  callback: function ($$v) {
                                    _vm.emergencyContactPhone = $$v
                                  },
                                  expression: "emergencyContactPhone",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-title-wrap" }, [
      _c("h3", { staticClass: "title" }, [_vm._v("İletişim Bilgileri")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-title-wrap" }, [
      _c("h3", { staticClass: "title" }, [
        _vm._v("Acil Durum Kişisi Bilgileri"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }